export default __webpack_public_path__ + "static/media/slider-nav.12900605.svg";